import { cloneDeep } from "bootstrap-vue/esm/utils/clone-deep";

export const initial_state = {
  env: {
    version: process.env.VUE_APP_VERSION
  }
};

export default cloneDeep(initial_state);
